import React from 'react';
import { colors } from '../theme';

// P19: Collaborative Discourse Over Obsequious Compliance.
//
// This panel surfaces tradeoffs as italic notes, NOT warnings. No red errors,
// no blocking validation, no "Are you sure?" interruptions. The user is the
// author of their character; our job is to surface context, not correct it.
//
// Examples:
//   "With Str 8 you'll struggle to carry heavy armor."
//   "This party has no healer — a Cleric or Druid would fill that role."
//   "Wearing Chain Mail caps your DEX bonus and gives Stealth disadvantage."

const ObservationPanel = ({ observations = [] }) => {
  if (!observations.length) return null;

  return (
    <section
      data-testid="observation-panel"
      style={{
        marginTop: 16,
        padding: 14,
        background: 'transparent',
        borderLeft: `3px solid ${colors.borderAccent}`,
        borderRadius: 4,
      }}
      aria-label="Observations about this character"
    >
      <h4
        style={{
          margin: '0 0 8px 0',
          fontSize: 12,
          letterSpacing: 1,
          textTransform: 'uppercase',
          color: colors.textSecondary,
          fontWeight: 'normal',
        }}
      >
        Things to consider
      </h4>
      <ul
        style={{
          margin: 0,
          paddingLeft: 18,
          color: colors.textMuted,
          fontStyle: 'italic',
          fontSize: 13,
          lineHeight: 1.5,
        }}
      >
        {observations.map((note, i) => (
          <li key={i} style={{ marginBottom: 6 }}>
            {note}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ObservationPanel;
